import { $Q, $Qll } from "../utils/query-selector";
import { readChangeStep } from "./funnel-upsell";
import { concatRegexp } from "./quantity-change";

/**
 * Change class element to active, and remove another clases with that.
 *
 * @param {string} index - data element result index for the active.
 * @param {String} content - Class element for search.
 */

function setActiveContent(dataActive, content) {
  const contentBtn = $Qll(content);

  contentBtn.forEach((element) => {
    if (element.dataset.index === dataActive) {
      element.classList.add('active');
    } else {
      element.classList.remove('active');
    }
  });
}

/**
 * Filter which option is active
 * @param {node} node - variant listen change
 * @returns {node} - variant active
 * @author Daniel Santos
 */
const filterOptionActive = (node) => $Qll('.funnel__options', node).length &&
    $Qll('.funnel__options', node)
      .filter((option) => option.classList.contains('active'))[0]

/**
 * Get next and when variant change continuos funnel
 * @param {node} node - funnel parent
 * @returns {null} stop called
 * @author Daniel Santos
 */
export function nextStep(node) {
  if (!node || !node.classList.contains('funnel-product-js')) return;

  const option = filterOptionActive(node)

  if (option.dataset.index < 4 && option.nextElementSibling) {
    option.nextElementSibling.click()
  }
}

/**
 * Validate quantity of options in variants and
 * if some variant has just one option
 * continuos to the next step
 * @param {node} nodeOption - funnel step element
 * @author Daniel Santos
 */
function oneOptionNextStep(nodeOption) {
  if ($Q('.variant__input[data-length="1"]', nodeOption)) nextStep($Q('.funnel-product-js'))
}

/**
 * Read if upsell has product selected
 * Adding prices of selected products
 * @return {number} - Return result of add or 0 if there are not card
 * @author Daniel Santos
 */
export function getUpsellTotalPrice() {
  const upsellProductsSelected = $Qll('.funnel-product-card[data-checked="true"]')

  if (!upsellProductsSelected.length) return 0;

  return upsellProductsSelected.reduce((count, el) => {
    const priceRaw = $Q('[data-price-raw]', el)

    if (!priceRaw) return;

    const priceByProdutCard = Number.parseInt(priceRaw.dataset.priceRaw, 10)

    return count + priceByProdutCard
  }, 0)
}

/**
 * Adding total prices
 * @param {node} target - Element with dataset.price of the product funnel
 * @param {number} upsellTotalPrice total price of funnel upsell
 * @returns {number} Funnel total price
 * @author Daniel Santos
 */
function totalFunnelPrice(target, upsellTotalPrice) {
  let funnelTotalPrice =
    (Number.parseInt(target.dataset.price, 10) + upsellTotalPrice)
  funnelTotalPrice = funnelTotalPrice / 100

  return funnelTotalPrice
}

/**
 * Get total prices of funnel upsell and funnel product
 * And render total price in price container
 * @param {node} target - Node element parent of price container
 * @returns null - stop calle
 * @author Daniel Santos
 */
export function renderTotalPrice(target) {
  const buttonFunnelPriceElement = $Q('.price-product-js.funnel-price .regular', target)
  const stepShowPrice = $Q('.price-product-js.funnel-main-price .regular')

  if (!buttonFunnelPriceElement) return;

  const upsellTotalPrice = getUpsellTotalPrice()
  const funnelTotalPrice = totalFunnelPrice(target, upsellTotalPrice)

  if (!funnelTotalPrice) return;

  const funnelTotalPriceParse =
    concatRegexp(
      buttonFunnelPriceElement.innerText,
      funnelTotalPrice.toFixed(2),
    )

  buttonFunnelPriceElement.textContent = `${funnelTotalPriceParse}`

  if (stepShowPrice) stepShowPrice.textContent = `${funnelTotalPriceParse}`
}

/**
 * Add upsell total price with funnel product price
 * @returns null - stop called
 * @author Daniel Santos
 */
function calculateFunnelTotalPrice() {
  const lastStepNode = $Q('.funnel__options.active .last-index');
  const buttonFunnel = $Q('.variant__option-js.btn-cart-js.active');

  if (!lastStepNode || !buttonFunnel) return;
  renderTotalPrice(buttonFunnel)
}

/**
 * Change class element to active, and remove another clases with that.
 * @param {node} element - node to active for the elements.
 * @param {nodeList} nodelist - list of nodes of the element.
 * @param {node} childrenNode - specify the children node for affect
 * @param {boolean} funnel indicates if the elements to be affected are a funnel
 */

function setColorActive({element, nodelist, childrenNode, funnel}) {
  nodelist.forEach((el) => {
    if (el.classList.contains('active')) {
      el.classList.remove('active');
      if (funnel === true) {
        el.classList.add('selected');
      }
    }
  });

  element.classList.toggle('active');
  const activeIndex = element.dataset.index;
  setActiveContent(activeIndex, childrenNode);
  readChangeStep();
  oneOptionNextStep(element);
  calculateFunnelTotalPrice();
}

/**
 * Create function with a callback for have break
 * Stop for with: return true in the callback
 * @param {array} nodelist - array of the funnel step nodes
 * @param {functino} cb - callback
 */
function loopBreak(nodelist, cb) {
  for (let i = 0; i < nodelist.length; i++) {
    if (cb(nodelist[i])) {
      break
    }
  }
}

function skipSteps({
  element,
  nodelist,
  funnel}) {

  if (!funnel) return;

  // loopBreak(nodelist, (node) => {
  //   const nodeVariants = $Qll('.variant__label', node)
  //   if (node.dataset.index === element.dataset.index) {
  //     return true;
  //   }

  //   if (!node.classList.contains('selected')) {
  //     node.classList.add('selected')

  //     if (nodeVariants.length && !nodeVariants[0].checked) {
  //       nodeVariants[0].click()
  //     }
  //   }
  // })
}

/**
 * Change class element to active, and remove another clases with that.
 * @param {node} element - node to active for the elements.
 * @param {node} childrenNode - specify the children node for affect
 * @param {boolean} funnel indicates if the elements to be affected are a funnel
 */

export function onClickToggle(nodes, childrenNode, funnel) {
  const radioElements = $Qll(nodes)

  if (!radioElements.length) return;

  radioElements.forEach((element, i, array) => {
    element.addEventListener('click', (e) => {
      const setColorConfig = {
        element,
        nodelist: radioElements,
        childrenNode,
        funnel,
      }

      // If click event is from this element then go next step
      if (e.target.classList.contains('js-collection-next-button')) {
        setColorConfig.element = array[i + 1]
      }

      skipSteps(setColorConfig)
      setColorActive(setColorConfig);
    })
  });
}

export function openPopup() {
  if (document.querySelectorAll('.funnel-product__description em').length > 0) {
    var popupOpener = document.querySelector('.funnel-product__description em');
    var popup = document.querySelector('.funnel-product__description-popup');
    var popupClose = document.querySelector('.funnel-product__description-popup__close-button');
    var popupOverlay = document.querySelector('.funnel-product__description-popup-overlay');

    popupOpener.addEventListener('click', function() {
      popup.classList.add('active');
    })

    popupClose.addEventListener('click', function() {
      popup.classList.remove('active');
    })

    popupOverlay.addEventListener('click', function() {
      popup.classList.remove('active');
    })
  }
}